interface Props {
    id: string;
}

const BetaConnectorRibbon = ({ id }: Props) =>
    ["googlesheets", "gmail", "googledocs", "googlecalendar"].includes(id) ? 
    <span className='ribbon'>Beta</span> : null;


export default BetaConnectorRibbon;
